export const colorModeManager = {
  get: (init?: 'light' | 'dark') => {
    try {
      const storedMode = localStorage.getItem('chakra-ui-color-mode');
      console.log('ColorModeManager GET:', storedMode);
      return (storedMode as 'light' | 'dark' | undefined) || init;
    } catch (e) {
      console.error('ColorModeManager GET error:', e);
      return init;
    }
  },
  set: (value: 'light' | 'dark') => {
    try {
      console.log('ColorModeManager SET:', value);
      localStorage.setItem('chakra-ui-color-mode', value);
      // Also update the data-theme attribute immediately
      document.documentElement.setAttribute('data-theme', value);
    } catch (e) {
      console.error('ColorModeManager SET error:', e);
    }
  },
  type: 'localStorage' as const,
};